import { BreakpointWrapper, Breakpoints, Container, ContainerGutter } from '@volkswagen-onehub/components-core';
import React from 'react';
import { vehicleEntity } from '../../../../../entities/vehicle-entity';
import { useVehicleImage } from '../selector-view/hooks/use-vehicle-image';
import { VehicleImage, VehicleImageMobile } from '../ui/vehicle-image';
import { VehicleInfo } from '../ui/vehicle-info';
import { VehicleDesktopContainer } from '../ui/vehicle-selected-styles';

export const VehicleSingleView = () => {
	const { displayImage, etiquetas, setIsLateralImageLoaded } = useVehicleImage({
		lateralImage: vehicleEntity.lateralImage,
		etiquetas: vehicleEntity.etiquetas,
		loadLateralImage: true,
	});

	const vehicleTitle = vehicleEntity.salesgroup?.title || vehicleEntity.carline?.title || '';

	return (
		<>
			<BreakpointWrapper max={Breakpoints.b960}>
				<Container
					horizontalAlign={'center'}
					verticalAlign={'center'}
					wrap={'always'}
					data-testid={'sigle-view-container-mobile'}
					gutter={ContainerGutter.static200}
				>
					<VehicleImageMobile
						etiquetas={etiquetas}
						displayImage={displayImage({ lateral: true })}
						alt="Imagen lateral del vehículo"
						onError={() => setIsLateralImageLoaded(false)}
					/>
					<VehicleInfo
						title={vehicleTitle}
						isNew={Boolean(vehicleEntity?.carline?.nuevo)}
						motorization={vehicleEntity.motorizacion}
						hasCta={false}
					/>
				</Container>
			</BreakpointWrapper>

			<BreakpointWrapper min={Breakpoints.b960}>
				<VehicleDesktopContainer data-testid={'sigle-view-container-desktop'}>
					<VehicleInfo
						title={vehicleTitle}
						isNew={Boolean(vehicleEntity?.carline?.nuevo)}
						motorization={vehicleEntity.motorizacion}
						hasCta={false}
					/>
					<VehicleImage
						etiquetas={etiquetas}
						displayImage={displayImage({ lateral: true })}
						alt="Imagen lateral del vehículo"
						onError={() => setIsLateralImageLoaded(false)}
					/>
				</VehicleDesktopContainer>
			</BreakpointWrapper>
		</>
	);
};
